<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/WK9jr7/images/cover.jpg?1684305980762" alt="This image is the cover for the book Fire Island"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Fire Island
      </h1>
      <p class="bookDescription body article font2">
        <p>Fire Island, or Great South Beach as it is also known, is a 32-mile long sliver of a barrier beach located just off the South Shore of Long Island. Always a wild, lonely and untamed wilderness, its shores, waterways and the lands surrounding it have given us innumerable stories -- some inspirational, some frightening, but all of them intriguing. The stories in this book portray people and events from the island's earliest days, when it served Native Americans as a rich hunting, fishing and whaling site until the present day and its use as a U.S. National Seashore and National Wilderness Area.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jack Whitehouse
      </h2>
      
      <p class="authorDescription body article">Jack Whitehouse grew up on the South Shore of Long Island, becoming a regular visitor to Fire Island's Cherry Grove and Fire Island Pines beginning in the early 1950s. In 1955, he took his first sailing lesson on the Great South Bay, eventually teaching sailing for the Wet Pants Sailing Association in the early 1960s. Following graduation from Brown University, in 1968 Jack received his commission as an ensign in the United States Navy. From 1968 to 1971, he served aboard the destroyer USS Buck (DD-761) for two deployments to Vietnam. In 1971, he became the executive officer and then the commanding officer of the patrol gunboat USS Chehalis (PG-94). In the early 1970s, Jack became the first U.S. Navy exchange officer with the Royal Norwegian navy. In 1974, he qualified as an officer of the deck (underway) on a Norwegian warship. He served with the Norwegian navy for a total of twenty months in frigates, patrol boats and submarines in waters north of the Arctic Circle. In 1976, Jack joined the U.S. Foreign Service, serving abroad for most of his career. In 1995, he and his wife, Elaine Kiesling, and son, John, returned to the South Shore where he and Elaine make their home today. Jack wanted to write Fire Island: Heroes & Villains on Long Island's Wild Shore after completing research for his earlier book, 13 Legends of Fire Island and the Great South Bay, a work of historical fiction. He discovered that the true-to-life history of the beach is as enthralling as any work of fiction. Jack is also the author of Sayville Orphan Heroes, the Cottages of St. Ann's. He writes for Fire Island Tide Newspaper and lectures on both the history of Fire Island and the Church Charity Foundation orphanage once located in Sayville. In 2010, he won the first-place award from the Press Club of Long Island for his regular column in the Fire Island Tide Newspaper.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5f55f25c